import * as React from "react";
import * as eventService from "../../models/services/eventService";
import * as recordService from "../../models/services/recordService";
import { AppUtils } from "../../framework/appUtils";
import { infiniteListPageSize } from "../../models/common/webConsts";
import { IModulePartnerListItems } from "source/models/modulePartner/modulePartnerListItems";
import { ModulePartnersDialogCompanyList } from "./ModulePartnersDialogCompanyList";
import { useEffect } from "react";
import { DatabaseRecordType } from "ui/Scripts/source/models/enums";

interface IModulePartnersSettingsProp {
    databaseRecordType: DatabaseRecordType;
    canAddPartner: boolean;
    canRemovePartner: boolean;
    companyId: string;
    onOk: () => void;
}

interface IModulePartnersSettingsState {
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    eventPartnerListItems: IModulePartnerListItems;
}

export const ModulePartnersSettings = (props: IModulePartnersSettingsProp) => {
    const [state, setState] = React.useState<IModulePartnersSettingsState>({
        filter: "",
        sortColumn: "name",
        sortOrderIsAsc: true,
        eventPartnerListItems: null
    });
    
    const handleGetPartnerListItems = async (page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, refreshList: boolean): Promise<IModulePartnerListItems> => {
        return props.databaseRecordType === DatabaseRecordType.Event
            ? await AppUtils.callService(() => eventService.getEventPartnerListItems(props.companyId, !refreshList ? infiniteListPageSize : (page * infiniteListPageSize), !refreshList ? page : 1, filter, sortColumn, sortOrderIsAsc), false)
            : await AppUtils.callService(() => recordService.getRecordUserPartnerListItems(props.companyId, !refreshList ? infiniteListPageSize : (page * infiniteListPageSize), !refreshList ? page : 1, filter, sortColumn, sortOrderIsAsc), false);
    };

    useEffect(() => {
        const fetchData = async () => {
            const eventPartnerListItems = await handleGetPartnerListItems(1, state.filter, state.sortColumn, state.sortOrderIsAsc, false);
            if (!eventPartnerListItems) return;
            setState(prevState => ({ ...prevState, eventPartnerListItems }));
        };

        fetchData();
    }, []);

    if (!state.eventPartnerListItems) return null;

    return (
        <ModulePartnersDialogCompanyList
            databaseRecordType={props.databaseRecordType}
            canAddPartner={props.canAddPartner}
            canRemovePartner={props.canRemovePartner}
            companyId={props.companyId}
            filter={state.filter}
            sortColumn={state.sortColumn}
            sortOrderIsAsc={state.sortOrderIsAsc}
            eventPartnerListItems={state.eventPartnerListItems}
            onGetPartnerListItems={handleGetPartnerListItems}
        />
    );
};